import axios from 'axios'
import type { Router } from 'vue-router'

export const http = axios.create({
  // Em prod aponta pro subdomínio da API (definido em .env.production).
  // Em dev fica vazio e o proxy do Vite roteia /api, /sanctum, etc. para o nginx.
  baseURL: import.meta.env.VITE_API_URL ?? '',
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
  },
})

let routerRef: Router | null = null

export function bindRouterForAuthRedirect(router: Router): void {
  routerRef = router
}

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const sessionEnded = error.response?.status === 401
      || (error.response?.status === 403 && error.response?.data?.error === 'account_inactive')

    if (sessionEnded && routerRef) {
      const current = routerRef.currentRoute.value.path
      if (current !== '/login') {
        routerRef.push({ path: '/login', query: { redirect: current } })
      }
    }
    return Promise.reject(error)
  },
)
